import { render, staticRenderFns } from "./option-picker.vue?vue&type=template&id=540244fa&scoped=true"
import script from "./option-picker.vue?vue&type=script&lang=js"
export * from "./option-picker.vue?vue&type=script&lang=js"
import style0 from "./option-picker.vue?vue&type=style&index=0&id=540244fa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540244fa",
  null
  
)

export default component.exports